import { useTranslation } from 'react-i18next';

export const SecondaryPrice = ({ formattedPrice, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <span className="text-text_muted">{formattedPrice}</span>
      <p className="text-[10px] text-text_muted leading-tight mt-0.5" data-testid="price-disclaimer">
        *{t('currency.disclaimer')}
      </p>
    </div>
  );
};
